const topics = [
  { label: '明星塌房', heat: '爆' },
  { label: '直播翻车', heat: '热' },
  { label: '综艺内幕', heat: '热' },
  { label: '品牌解约', heat: '新' },
  { label: '网红纠纷', heat: '热' },
  { label: '财务造假', heat: '爆' },
  { label: '私密视频', heat: '爆' },
  { label: '合约撕逼', heat: '热' },
  { label: '选秀黑幕', heat: '热' },
  { label: '代言塌房', heat: '新' },
  { label: '饭圈乱象', heat: '新' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🔖 热门话题
          </h2>
          <p className="text-sm text-foreground-600">
            大家都在讨论的热门话题标签，点击查看相关爆料内容
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-background-300 bg-background-50 hover:border-primary-300 hover:bg-primary-50/40 transition-all duration-300 cursor-pointer no-underline group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span
                className={`px-2 py-0.5 rounded-full text-xs font-bold whitespace-nowrap ${
                  topic.heat === '爆'
                    ? 'bg-primary-500 text-white'
                    : topic.heat === '热'
                    ? 'bg-accent-500 text-accent-950'
                    : 'bg-secondary-200 text-secondary-700'
                }`}
              >
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}